import { ProgressSpinnerModule } from 'primeng/progressspinner'; 
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ClickOutsideModule } from 'ng-click-outside';
import { RouterModule } from '@angular/router';
import { NavMenuComponent, SideMenuComponent, AccountMenuComponent} from './index';
import { AppCommonModule } from '@modules/common/app-common.module'; 
import { TableModule } from 'primeng/table';
import {CheckboxModule} from 'primeng/checkbox';
import { SettingMenuComponent } from './setting-menu/setting-menu.component';

@NgModule({
  declarations: [
    NavMenuComponent,
    SideMenuComponent,
    AccountMenuComponent, 
    SettingMenuComponent 
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    RouterModule,
    ClickOutsideModule,
    AppCommonModule,
    TableModule,
    CheckboxModule,
    FormsModule,
    ProgressSpinnerModule
  ],
  providers: [
  ],
  exports: [NavMenuComponent]
})
export class NavMenuModule { }
